<template>
  <page-option :disable-add="!checkAccess('style.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-account</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.style.name') }}</div>
    </template>
    <template #below-toolbar>
      <FilterSearch
        canShowInSearch
        v-model="params"
        :disableCreate="!checkAccess('style.create')"
        placeholder="Tìm kiếm theo tên"
        @click:create="onCreateItem()"
      >
        <div class="d-flex flex-sm-row flex-column flex-warp">
          <div class="filter-item">
            <field-group
              v-model="params.workspace_id"
              background-color="#FFFFFF"
              clearable
              dense
              item-text="name"
              item-value="id"
              :items="workspace.items"
              :label="$t('sidebar.workspace.name')"
              :loading="workspace.loading"
              no-label
              outlined
              hide-details
              typeInput="v-select"
            >
            </field-group>
          </div>
        </div>
      </FilterSearch>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
      >
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>{{ item.updated_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ item.created_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
    <StyleDialog ref="dialog" @reset="onReset" :workspace="workspace" />
  </page-option>
</template>

<script>
import FilterSearch from '@layouts/filter-search.vue'
import { API_STYLE, API_WORKSPACE } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import StyleDialog from './style-dialog.vue'
export default {
  mixins: [],
  components: {
    FilterSearch,
    StyleDialog,
  },
  data: (vm) => ({
    workspace: {
      loading: false,
      items: [],
    },
    layer: { loading: false, items: [] },
    default_params: { with: 'workspace,layer' },
    params: { search: '', workspace_id: null, layer_id: null },
    menus: [
      {
        type: 'download',
        handler: (item) => vm.onDownloadItem(item),
        disabled: (item) => !vm.checkAccess('style.update', item),
      },
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('style.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('style.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Không gian làm việc',
        align: 'start',
        sortable: true,
        value: 'workspace.name',
      },
      {
        trans: 'sidebar.layer.name',
        align: 'start',
        sortable: true,
        value: 'layer.name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    loading: false,
  }),
  watch: {
    // 'params.workspace_id': {
    //   handler(value) {
    //     this.layer.items = []
    //     this.params.layer_id = null
    //     this.layer.loading = true
    //     API_LAYER.list({ workspace_id: value })
    //       .then((res) => {
    //         this.layer.items = res.data
    //       })
    //       .finally(() => {
    //         this.layer.loading = false
    //       })
    //   },
    // },
  },
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_STYLE
    },
  },
  created() {
    this.workspace.loading = true
    API_WORKSPACE.list()
      .then((res) => {
        this.workspace.items = res.data
      })
      .finally(() => {
        this.workspace.loading = false
      })
  },
  mounted() {},
  methods: {
    onDownloadItem(item) {
      API_STYLE.download(item.id)
    },
    onResetPassword(item) {
      this.$refs.resetdialog.open(item)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addText(
          'Hành động này sẽ cài đặt lại trình bày bản đồ của lớp bản đồ về mặc định'
        )
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_STYLE.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
  },
}
</script>
